import { Typography } from '@navi/web-ui/lib/primitives';

const InactiveTextContainer = () => {
  return (
    <div className="flex justify-center items-center pt-10">
      <Typography variant="p4" color="var(--navi-color-gray-c3)" className="text-center">
        To edit details, please mark this <br /> agent as active
      </Typography>
    </div>
  );
};

export default InactiveTextContainer;
